module.exports = __webpack_public_path__ + "img/icon2.eac65b45.png";